<app-event-form
  [formGroup]="formGroup"
></app-event-form>
